/** 
  All of the common routes for the frontend are added here,
  You can add a new route, customize the routes and delete the common routes here.

  You have to set the `sidebar_item: true` if you have to show the route in Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
  11. The `sidebar_item` key is used to show/hide menu in Sidenav.
  12. The `lang_attr` key is used to make it multi-lingual.
*/

// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import Jobs from "layouts/jobs";
import JobDetails from "layouts/jobs/jobdetails";
import InterfaceSettings from "layouts/settings/interface_settings";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "",
    icon: "dashboard",
    route: "/",
    component: <Dashboard />,
    sidebar_item: true,
    lang_attr: "dashboard",
    permission: "any",
  },
  {
    type: "collapse",
    name: "Jobs",
    key: "jobs",
    icon: "checklist",
    route: "/jobs",
    component: <Jobs />,
    sidebar_item: true,
    lang_attr: "jobs_text",
    permission: "can_view_gbwm",
  },
  {
    type: "collapse",
    name: "Job Details",
    key: "job-details",
    icon: "job_details",
    route: "/job/:id",
    component: <JobDetails />,
    lang_attr: "job_details",
    permission: "can_view_gbwm",
  },
  {
    type: "collapse",
    name: "Settings",
    key: "settings",
    icon: "settings",
    permission: ["can_manage_interface_settings"],
    lang_attr: "settings",
    sidebar_item: true,
    children: [
      {
        type: "collapse",
        name: "Interface Settings",
        key: "interface-settings",
        icon: "settings",
        route: "/interface-settings",
        permission: "can_manage_interface_settings",
        lang_attr: "interface_settings",
        sidebar_item: true,
        component: <InterfaceSettings />,
      },
    ],
  },
];

export { routes };
